<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>LTV (计算方式:付费/注册)</span>
        </div>
        <el-form ref="queryForm" :model="queryParams" :inline="true">
          <el-form-item label="国家" prop="startDate">
            <el-select v-model="queryParams.country" filterable placeholder="请选择">
              <el-option
                v-for="item in country"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <el-button icon="el-icon-download" :loading="loading" size="mini" @click="exportData()">导出</el-button>
          </el-form-item>
        </el-form>

        <div ref="chartContainer" style="width: 100%; height: 400px;;margin-bottom: 20px" />

        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="date"
            label="日期"
            width="100px"
          />
          <el-table-column
            prop="reg_count"
            label="新增人数"
          />
          <el-table-column
            prop="ltv_record.0.ltv"
            label="当日"
          />
          <el-table-column
            prop="ltv_record.1.ltv"
            label="LTV1"
          />
          <el-table-column
            prop="ltv_record.2.ltv"
            label="LTV2"
          />
          <el-table-column
            prop="ltv_record.3.ltv"
            label="LTV3"
          />
          <el-table-column
            prop="ltv_record.4.ltv"
            label="LTV4"
          />
          <el-table-column
            prop="ltv_record.5.ltv"
            label="LTV5"
          />
          <el-table-column
            prop="ltv_record.6.ltv"
            label="LTV6"
          />
          <el-table-column
            prop="ltv_record.7.ltv"
            label="LTV7"
          />
          <el-table-column
            prop="ltv_record.8.ltv"
            label="LTV15"
          />
          <el-table-column
            prop="ltv_record.9.ltv"
            label="LTV30"
          />
          <el-table-column
            prop="ltv_record.10.ltv"
            label="LTV60"
          />
          <el-table-column
            prop="ltv_record.11.ltv"
            label="LTV90"
          />
        </el-table>

      </el-card>
    </template>

  </BasicLayout>
</template>

<script>
import { getLtvData } from '@/api/statistics/user_remain'
import echarts from 'echarts'
import { getCacheQuery, setCacheQuery } from '@/utils'

export default {
  name: 'Ltv',
  data() {
    return {
      country: [],
      chartData: {},
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        country: ''
      },
      loading: false,
      options: [],
      tableData: [],
      date: [],
      chart: {},
      option: {}
    }
  },
  created() {
    this.getTables(undefined)
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleKeyUp() {
      this.onSubmit()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      this.getTables({})
    },
    getTables(event) {
      this.loading = true
      this.queryParams.type = 0
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getLtvData(this.queryParams).then(res => {
        this.loading = false
        setCacheQuery(this.$options.name, this.queryParams)
        if (res.code === 200) {
          this.queryParams.startDate = res.data.req.startDate
          this.queryParams.endDate = res.data.req.endDate
          const data = res.data.data.Result
          const country = res.data.data.Country
          this.country = [{ value: '', label: '全部' }]
          for (const i in country) {
            this.country.push({ value: i, label: country[i] })
          }
          const ltvData = {}
          for (let i = 0; i <= 11; i++) {
            ltvData[i] = []
          }
          this.date = []
          this.date = []
          for (const k in data) {
            const val = data[k]
            this.date.push(val.date)
            for (const i in val.ltv_record) {
              const record = val.ltv_record[i]
              const _i = parseInt(i)
              if (ltvData[_i]) {
                ltvData[_i].push(record.ltv)
              }
            }
          }

          this.option.xAxis.data = this.date
          for (const i in ltvData) {
            if (this.option.series[i]) {
              this.option.series[i].data = ltvData[i]
            }
          }
          this.chart.setOption(this.option)

          // console.log('tableData', data)
          this.tableData = data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    numFormatter(row, column, cellValue, index) {
      return cellValue + '%'
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          // text: '新增留存'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: ['LTV当天', 'LTV1', 'LTV2', 'LTV3', 'LTV4', 'LTV5', 'LTV6', 'LTV7', 'LTV15', 'LTV30'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: { readOnly: false },
            // magicType: { type: ['line', 'bar'] },
            // restore: {},
            // saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: 'LTV当天',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: 'LTV1',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: 'LTV2',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: 'LTV3',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }, {
            name: 'LTV4',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: 'LTV5',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: 'LTV6',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: 'LTV7',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }, {
            name: 'LTV15',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: 'LTV30',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: 'LTV60',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: 'LTV90',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
        ]
      }
      this.chart.setOption(this.option)
    },
    exportData() {
      this.loading = true
      this.queryParams.type = 2
      getLtvData(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
